import React, { useState } from 'react';
import { Container, Card, Row, Col, Form } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import { Formik } from 'formik';
import useOneTimePassword from './hooks/useOneTimePassword';
import { Loader } from 'semantic-ui-react';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import './ProfileInformation.scss';
import ApiEncrypt from '../../../utils/Encrypt';
import ToastMessage from '../../../components/common/ToastMessage';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { logout } from 'src/redux/app/userSlice';
import timerImage from '../../../img/Timer.svg';

const OneTimePassword = ({
  email,
  currentStep,
  nextStep,
  prevStep,
  OTPExpiry,
  OTPLength,
  OTPAttempts,
  details,
}) => {
  const {
    schema,
    serverError,
    accountLocked,
    loader,
    maskEmail,
    validateOTP,
    generateOTP,
    setOneTimePassword,
  } = useOneTimePassword({
    email,
    nextStep,
    OTPExpiry,
    OTPLength,
    OTPAttempts,
  });

  const dispatch = useDispatch();
  const [redirectToSuccess, setRedirectToSuccess] = useState(false);
  //need to check
  /*if ( serverError ) {
    return <Redirect to="/admin/server-error" push={true}></Redirect>;
  }
  // need to check
  if ( accountLocked ) {
    return <Redirect to="/admin/otp-error" push={true}></Redirect>;
  }
  */

  const { encryptData } = ApiEncrypt();
  const updateUserAPI = async () => {
    const payload = {
      UpdateUser: {
        Oid: details.Oid,
        UserID: details.UserID,
        Password: encryptData(details.Password, false),
        Status: details.Status,
        SuperUser: details.SuperUser,
        CurrentPassword: encryptData(details.CurrentPassword, false),
        UserType: details.UserType,
      },
    };

    try {
      const response = await axiosInstance.put(
        APIEndpoints.getUpdateUserAPIResource(),
        payload,
      );
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        localStorage.setItem('pwd-reset', true);
        return new Promise((resolve, reject) => {
          dispatch(logout());
          setRedirectToSuccess(true);
          setTimeout(() => {
            resolve('Success!');
          }, 100);
        });
      } else {
        return new Promise((resolve, reject) => {
          reject('We are unable to update the details. Please try again!');
          prevStep();
          toast.error(
            <ToastMessage
              type="error"
              subTitle="Current Password is incorrect."
            />,
          );
        });
      }
    } catch (e) {
      return new Promise((resolve, reject) => {
        reject(e);
        prevStep();
        toast.error(
          <ToastMessage
            type="error"
            subTitle="Current Password is incorrect."
          />,
        );
      });
    }
  };
  if (accountLocked) {
    dispatch(logout());
    return <Navigate to="/admin/otp-error" push={true}></Navigate>;
  }
  if (redirectToSuccess) {
    return <Navigate to="/admin/password-change-success"></Navigate>;
  }
  return currentStep === 2 ? (
    <Col md={8} className="otp-verify-container otp-verify-container-box">
      <div className="heading-otp">
        <Row>
          <Col md={8}>2-Step Verification</Col>
        </Row>
      </div>
      <Row className="mb-4">
        <Col md={12}>
          <p>
            We have sent a One Time Password (OTP) to the email{' '}
            {maskEmail(email)}. Please enter it below.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Formik
            validationSchema={schema}
            initialValues={{ oneTimePassword: '' }}
            onSubmit={(values, actions) => {
              //need to check
              actions.setStatus(undefined);
              validateOTP(values.oneTimePassword)
                .then(() => {
                  updateUserAPI().then(() => {
                    nextStep();
                  });
                })
                .catch((error) => {
                  actions.setStatus({
                    oneTimePassword: error,
                  });
                });
            }}
          >
            {({
              values,
              touched,
              errors,
              status,
              handleSubmit,
              handleChange,
              handleBlur,
              setStatus,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-5">
                    <Form.Label className="mb-0">One time password</Form.Label>
                    <Form.Control
                      type="input"
                      name="oneTimePassword"
                      placeholder=""
                      className={
                        status && status.oneTimePassword ? 'is-invalid' : ''
                      }
                      value={values.oneTimePassword}
                      isInvalid={errors.oneTimePassword}
                      onChange={(e) => {
                        handleChange(e);
                        const setOTP = e.currentTarget.value.trim();
                        setOneTimePassword(setOTP);
                        setStatus({ oneTimePassword: '' });
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        const setOTP = e.currentTarget.value.trim();
                        setOneTimePassword(setOTP);
                        setStatus({ oneTimePassword: '' });
                        console.log('status', status);
                        console.log('errors', errors);
                      }}
                    />
                    {status && status.oneTimePassword ? (
                      <Form.Control.Feedback type="invalid" className="mt-1">
                        <span>{status.oneTimePassword}</span>
                      </Form.Control.Feedback>
                    ) : (
                      errors.oneTimePassword && (
                        <Form.Control.Feedback type="invalid" className="mt-1">
                          <span>{errors.oneTimePassword}</span>
                        </Form.Control.Feedback>
                      )
                    )}
                    <p className="my-2">Enter OTP sent to you via email</p>
                  </Form.Group>
                  <Row>
                    <Col md={12} lg={8} sm={8}>
                      <span>
                        <img
                          className="timer-imag mr-2"
                          src={timerImage}
                          alt="Timer"
                        />
                        <span className="timer-pading-left">
                          {'The OTP will expire in'}{' '}
                          <span id="otp-timer">05:00</span>
                          {' minutes'}
                        </span>
                      </span>
                      <h4 className="resend-code">
                        {' '}
                        Did not get it?
                        <Link to="#" className="pl-1" onClick={generateOTP}>
                          Resend code.
                        </Link>{' '}
                      </h4>
                    </Col>
                    <Col>
                      <GenericButton
                        type="submit"
                        variant="primary"
                        disable={loader}
                        className="float-right"
                      >
                        Continue
                      </GenericButton>
                    </Col>
                  </Row>
                  {/*{loader && (
                      <div className="custom-loader mt-0 mt-md-3 mt-lg-4 d-flex justify-content-end">
                        <div className="loader-icon position-relative mr-4">
                          <Loader
                            className="text-dark font-weight-bold loader-color marginTop-Login-loader"
                            size="small"
                            active
                          />
                        </div>
                        <div className="text-dark font-weight-bold">Validating OTP...</div>
                      </div>
                    )} */}
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Col>
  ) : null;
};

export default OneTimePassword;
